import { ComponentProps } from "react"
import { twMerge } from "tailwind-merge"

type AnchorProps = ComponentProps<'a'>

export function Anchor(props: AnchorProps) {
    return (
        <a {...props}
            className={twMerge(
                "cursor-pointer flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent",
                props.className)}>

        </a>
    )
}